<div style="height: 98dvh; display: flex; justify-content: space-between; flex-direction: column">
  <div>
    <app-additional-action-header [title]="locale.currentTranslation.aboutPolicyholder"/>
    <div class="base-content-container">
      <div>
        <div>
          <img height="24" ngSrc="../../../../assets/img/voi-logo.svg" width="59">
        </div>
        <p class="text-body2 text-bold">{{ locale.currentTranslation.aboutPolicyholderHeadline }}</p>
        <p class="text-body2">{{ locale.currentTranslation.aboutPolicyholderTechnicalProblem }}</p>

        <div class="divider"></div>

        <p class="label1 text-bold">{{ locale.currentTranslation.aboutPolicyholderSupportHeadline }}</p>
        <p class="text-body2 text-bold">{{ locale.currentTranslation.aboutPolicyholderApp }}</p>
        <p class="text-body2">{{ locale.currentTranslation.aboutPolicyholderSupport }}</p>
        <p class="text-body2">{{ locale.currentTranslation.aboutPolicyholderBreadcrumb }}</p>

        <div class="divider"></div>

        <p class="label1 text-bold">{{ locale.currentTranslation.aboutPolicyholderWebsite }}</p>
        <p class="text-body2">{{ locale.currentTranslation.aboutPolicyholderChat }}</p>

        <a [href]="locale.currentTranslation.aboutPolicyholderWebsiteLink1"
           class="secondary-button text-body2 text-bold" rel="noopener"
           style="margin-top: 2em;"
           target="_blank">{{ locale.currentTranslation.aboutPolicyholderHelpButton1 }} <span><img
          height="20" ngSrc="../../../../../assets/img/external-link.svg" width="20"/></span></a>
        <a [href]="locale.currentTranslation.aboutPolicyholderWebsiteLink2"
           class="secondary-button text-body2 text-bold"
           rel="noopener" style="margin-top: 1em;"
           target="_blank">{{ locale.currentTranslation.aboutPolicyholderHelpButton2 }}
          <span><img height="20" ngSrc="../../../../../assets/img/external-link.svg" width="20"/></span></a>
      </div>
    </div>
  </div>
  <div style="padding: 0 22px 14px 22px">
    <app-footer/>
  </div>
</div>
